<div [class]="'agenx-input mb-input ' + extraClasses"
  [ngClass]="{'agenx-input--error': control.errors && control.touched, 'agenx-input--success': control.valid && control.touched}">
  <input [id]="idInput" [formControl]="control" class="agenx-input__input" [type]="type" [placeholder]="placeholder"
    [value]="value" [readonly]="readonly" (input)="returnChange($event)" (keydown.enter)="returnEnterPress($event)">
  <label [for]="idInput" class="agenx-input__label" [ngClass]="labelClasses"> {{ label }} </label>
</div>

